import React, { useState, useEffect } from 'react';
import useDidMount from 'app/hook/common/useDidMount';
import useNow from 'app/hook/common/useNow';
import dayjs from 'app/libs/dayjs';
import useToast from 'app/hook/common/useToast';

function NotySiteMaintenance({ dataName = null }) {
	const { getNow } = useNow();
	const { notyView } = useToast();

	const [init, setInit] = useState(false);
	const [data, setData] = useState({ env: [] });
	const [ViewComponent, setViewComponent] = useState(null);

	// 데이터 확인
	useDidMount(() => {
		let checkJsLoadTime;
		try {
			let count = 0;
			checkJsLoadTime = setInterval(() => {
				if (global[dataName] !== undefined) {
					setData(global[dataName]);
					clearInterval(checkJsLoadTime);
				}
				count += 1;
				if (count > 50) {
					clearInterval(checkJsLoadTime);
					console.log('NotySiteMaintenance: not working');
				}
			}, 150);
		} catch (err) {
			console.log(err);
		}
		return () => {
			clearInterval(checkJsLoadTime);
		};
	});

	// 미리알림 및 안내페이지
	useEffect(() => {
		const localGetName = 'NotySiteMaintenance';
		if (data.env === undefined) {
			localStorage?.removeItem(localGetName);
			return;
		}
		if (data.env?.length > 0) {
			const envCheck = data.env?.indexOf(process.env.REACT_APP_DEPLOY_ENV);
			if (envCheck < 0) return;
			if (!data.env) {
				localStorage?.removeItem(localGetName);
				return;
			}
			(async () => {
				const today = await getNow();
				const startTime = new Date(data.start);
				const endTime = new Date(data.end);

				const showTime = today >= startTime && today <= endTime;
				const beforeTime = Math.floor((today - startTime) / 1000 / 60);
				if (showTime) {
					const { default: Component } = await import('app/components/common/SiteMaintenance');
					setViewComponent(Component);
					setInit(showTime);
				}
				if (beforeTime >= -10) {
					// 로컬스토리지 확인 (1회알림)
					if (beforeTime >= 0) {
						localStorage?.removeItem(localGetName);
						return;
					}
					if (localStorage?.getItem(localGetName) === 'yes') return;
					localStorage?.setItem(localGetName, 'yes');

					// 토스트팝업
					const timeInfo =
						data.start.substring(0, 10) === data.end.substring(0, 10)
							? `${dayjs(data.start).format('YYYY년 M월 D일 HH시 mm분')} ~ ${dayjs(data.end).format('H시 mm분')}까지`
							: `${dayjs(data.start).format('YYYY년 M월 D일 HH시 mm분')} ~ ${dayjs(data.end).format('YYYY년 M월 D일 HH시 mm분')}`;
					notyView({
						text: `${Math.abs(beforeTime)}분 후 서비스 점검으로 이용이 제한됩니다.<div style="margin-top:5px;font-size:12px;color:#bbb">${timeInfo}</div>`,
						timeout: 20000,
						layout: 'top',
					});
				} else {
					localStorage?.removeItem(localGetName);
				}
			})();
		}
	}, [data, getNow, notyView]);

	// 화면
	return init && <ViewComponent data={data} />;
}

export default NotySiteMaintenance;
